var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/TreeContextMenu/ctx.ts";
import { equals } from 'ramda';
import React, { useCallback, useContext, useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var Ctx = /*#__PURE__*/React.createContext(null);
export var TreeContextMenuProvider = Ctx.Provider;
export function useNodeCtxMenu(params) {
  var ctx = useContext(Ctx);
  var onClickOpen = useCallback(function (e) {
    e.stopPropagation();
    !(ctx !== null && ctx !== void 0 && ctx.hideCtxMenu) && (ctx === null || ctx === void 0 ? void 0 : ctx.onOpen({
      x: e.clientX,
      y: e.clientY
    }, params.path));
  }, [ctx, params.path]);
  var onContextMenu = useCallback(function (e) {
    e.preventDefault();
    onClickOpen(e);
  }, [onClickOpen]);
  var open = ctx ? equals(ctx.path, params.path) : false;
  return useMemo(function () {
    return {
      onClickOpen: onClickOpen,
      onContextMenu: onContextMenu,
      open: open
    };
  }, [onClickOpen, onContextMenu, open]);
}